import { render, staticRenderFns } from "./TheTeacherTopbar2.vue?vue&type=template&id=b93f532e&scoped=true"
import script from "./TheTeacherTopbar2.vue?vue&type=script&lang=js"
export * from "./TheTeacherTopbar2.vue?vue&type=script&lang=js"
import style0 from "./TheTeacherTopbar2.vue?vue&type=style&index=0&id=b93f532e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93f532e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b93f532e')) {
      api.createRecord('b93f532e', component.options)
    } else {
      api.reload('b93f532e', component.options)
    }
    module.hot.accept("./TheTeacherTopbar2.vue?vue&type=template&id=b93f532e&scoped=true", function () {
      api.rerender('b93f532e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/layout/TheTeacherTopbar2.vue"
export default component.exports